import React from 'react'
import Layout from '../components/layouts/pricesmart'
import { graphql } from 'gatsby'
import Helmet from 'react-helmet'
import Header from '../components/pricesmart/header'
import Header2 from '../components/header'
import {
  BeneficiosWrapper,
  Beneficio,
  BeneficioIcono,
  BeneficioTitular,
  BeneficiosTitular,
  ReglamentoContainer,
} from '../components/pricesmart/beneficios'
import PromoBaner from '../components/pricesmart/promo-banner'
import {
  FdpContainer,
  FdpLogo,
} from '../components/pricesmart/facilidades-de-pago'
import Calculadora from '../components/pricesmart/calculadora'

class Home extends React.Component {
  render() {
    const { multicanalidad, pais, page: {frontmatter} } = this.props.data
    const footer = this.props.data.footer
      ? this.props.data.footer.edges.map(f => f.node)
      : null

    return (
      <Layout
        {...pais}
        footer={footer}
        contacto={frontmatter.contacto}
        disclaimer={frontmatter.disclaimer}
      >
        <Helmet
          title={frontmatter.title}
          meta={[{ name: 'description', content: frontmatter.description }]}
        />
        <Header2 {...pais} />
        <Header
          title={frontmatter.title}
          disclaimer={frontmatter.header_disclaimer}
          promesa={frontmatter.promesa}
          cta={frontmatter.cta}
          formUrl={frontmatter.formUrl}
          header_img={frontmatter.header_img}
          tarjeta_img={frontmatter.tarjeta_img}
        />
        <BeneficiosTitular>{frontmatter.description}</BeneficiosTitular>
        <BeneficiosWrapper>
          {frontmatter.beneficios.map((beneficio, i) => (
            <Beneficio key={i}>
              <BeneficioIcono>
                <img
                  src={beneficio.icono}
                  alt={beneficio.titular}
                  width="100"
                />
              </BeneficioIcono>
              <BeneficioTitular>{beneficio.titular}</BeneficioTitular>
              {beneficio.items && (
                <ul>
                  {beneficio.items.map((item, i) => (
                    <li key={i}>{item}</li>
                  ))}
                </ul>
              )}
            </Beneficio>
          ))}
        </BeneficiosWrapper>
        <ReglamentoContainer>
          <div>
            <a
              href="https://www.baccredomatic.com/sites/default/files/reglamento_pricecash_amex-visa_v2.pdf"
              target="_blank"
              rel="noopener noreferrer"
            >
              Reglamento
            </a>
            <a
              href="https://issuu.com/credomatic/docs/compaginacionlecturadigitalfolletoe?e=19500127/31587712"
              target="_blank"
              rel="noopener noreferrer"
            >
              Folleto explicativo de la tarjeta
            </a>
          </div>
        </ReglamentoContainer>
        <BeneficiosTitular>{frontmatter.calculadora_titular}</BeneficiosTitular>
        <Calculadora />
        <PromoBaner
          cta={frontmatter.promo_banner_cta}
          titular={frontmatter.promo_banner_titular}
          descripcion={frontmatter.promo_banner_descripcion}
          link={frontmatter.promo_banner_link}
          tarjeta_img={frontmatter.tarjeta_img}
          disclaimer={frontmatter.header_disclaimer}
          multicanalidad={multicanalidad}
        />
        <div>
          <BeneficiosTitular>
            {frontmatter.pago_plazos_titular}
          </BeneficiosTitular>
          <FdpContainer>
            {frontmatter.pago_plazos_logos.map((logo, i) => (
              <FdpLogo key={i}>
                <img src={logo.logo} alt={logo.alt} />
              </FdpLogo>
            ))}
          </FdpContainer>
        </div>
      </Layout>
    )
  }
}

export const query = graphql`
  query($pais: String!, $path: String!) {
    page: markdownRemark(frontmatter: { path: { eq: $path } }) {
      frontmatter {
        title
        description
        header_disclaimer
        disclaimer
        promesa
        cta
        formUrl
        header_img
        tarjeta_img
        beneficios {
          titular
          icono
          items
        }
        calculadora_titular
        calculadora_categorias {
          id
          titulo
          acumulacion
        }
        calculadora_total
        promo_banner_titular
        promo_banner_descripcion
        promo_banner_link
        promo_banner_cta
        pago_plazos_titular
        pago_plazos_logos {
          logo
          alt
        }
        date
        template
        pais
        contacto {
          titulo
          texto
          link
          icono
        }
      }
    }

    pais: contentfulPais(title: {eq: $pais}){
      title
      contryAbr
      countrySlug
    }

    multicanalidad: contentfulMulticanalidadLinks(
      identificador: { eq: "multicanalidad-tarjetas-cr" }
    ) {
      formLlamada
      telefono
      whatsapp
      form
    }

    footer: allContentfulFooter(filter: { pais: { eq: $pais } }) {
      edges {
        node {
          id
          type
          texto {
            texto
          }
        }
      }
    }
  }
`

export default Home
